import { CheckBoxIcon } from "../../../assets/img/svg/CheckBoxIcon";

import { CheckBoxStyled } from "./Checkbox.styled";

export const Checkbox = ({ variant = "dark", ...rest }) => {
  const isDark = variant === "dark";

  return (
    <CheckBoxStyled
      color="primary"
      icon={<CheckBoxIcon tag="default" isDark={isDark} />}
      checkedIcon={<CheckBoxIcon tag="checked" />}
      variant={variant}
      {...rest}
    />
  );
};
